import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { EmailVerificationSentLayout } from 'Organisms/EmailVerificationSentLayout';


export const EmailVerificationSentLayoutContainer = () => {
  const { pageContentResource } = usePageContentContext();

  return (
    <EmailVerificationSentLayout resource={pageContentResource} />
  );
};
